window.livewire.on('alert', message => {
    alert(message);
    location.reload();
});